
export const ProgramType = {
    ALL: { str: "전체", class: "" },
    ACADEMY: { str: "기술창업아카데미", class: "" },
    SUPPORT: { str: "창업기업 지원", class: " cat-2" },
    undefined: { str: "", class: "" },
}

export const ApplyStatus = {
    BEFORE: { str: "신청 전", class: "" },
    ENDED: { str: "신청 마감", class: " stt-2" },
    ING: { str: "신청 중", class: "" },
    undefined: { str: "", class: "" },
}

export const ApplicationType = {
    ALL: { str: "ALL", class: "" },
    MEMBER: { str: "MEMBER", class: " cnd-2" },
    undefined: { str: "", class: "" },
}